import FJActionConstant from "../../constant/FJActionConstant";

const initState = {
  status: FJActionConstant.CLOUD_STATUS_IDLE,
  done: [],
  undone: [],
  failed: [], // 上传云空间失败的文件列表
  uploadingMedia: null,
  space: window.fjcloud ? window.fjcloud.space : {total: 0, used: 0},
  cloudFUllMediaList: [], // 上传云空间失败的文件列表(原因是云空间已满)
};

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.CLOUD_STATUS_CHANGED: {
      return {
        ...state,
        status: action.data,
      }
    }
    case FJActionConstant.CLOUD_STATUS_UPDATE_ALL:{
      return {
        ...state,
        done: action.data.done,
        undone: action.data.undone,
        failed: action.data.failed,
        uploadingMedia: action.data.uploadingMedia,
      }
    }

    case FJActionConstant.CLOUD_SYNC_START: {
      return {
        ...state,
        uploadingMedia: action.data ? action.data.id : null
      }
    }

    case FJActionConstant.CLOUD_SPACE_CHANGED: {
      return {
        ...state,
        space: action.data
      }
    }

    case FJActionConstant.ADD_CLOUD_FULL_MEDIA: {
      return {
        ...state,
        cloudFUllMediaList: action.data
      }
    }

    case FJActionConstant.CLEAR_CLOUD_FULL_MEDIA: {
      return {
        ...state,
        cloudFUllMediaList: []
      }
    }

    default:
      return state;
  }
}
